<template>
    <div>
        <div class="flex justify-end gap-3">
            <vs-button color="primary" icon-pack="feather" icon="icon-settings"
                       @click="isChangeSetting = true" v-if="!isChangeSetting">
                {{ $t('settings.addSetting') }}
            </vs-button>
            <vs-button @click="saveChange" v-if="isChangeSetting" icon-pack="feather" icon="icon-check">
                {{ $t('button.save') }}
            </vs-button>
            <vs-button color="danger" type="border" @click="cancelChange" v-if="isChangeSetting" icon-pack="feather"
                       icon="icon-x">{{
                    $t('button.cancel')
                }}
            </vs-button>
        </div>

        <div class="mt-6">
            <draggable @end="endMove($event)" :list="dataView" v-bind="dragOptions" @start="isDraging = true"
                       handle=".handle">
                <transition-group type="transition" :name="!isDraging ? 'flip-list' : null">
                    <div v-for="(item, index) in dataView" :key="index" class="vx-card px-6 py-2 mt-4 ">
                        <div class="vx-row">
                            <div :class="isChangeSetting ? 'vx-col w-1/12 flex item-center justify-center' : 'hidden'">
                                <feather-icon svg-classes="h-6 w-6" icon="MenuIcon" class="text-primary handle"
                                              v-if="item.status > 3"></feather-icon>
                            </div>
                            <div :class="isChangeSetting ? 'vx-col w-3/12' : 'vx-col w-1/2'">
                                <vs-input v-model="item.title" class="w-full" v-validate="'required'" name="title"
                                          :readonly="!isChangeSetting" :disabled="isChangeSetting && item.status < 4"/>
                                <span class="text-danger text-sm">{{ errors.first('title') }}</span>
                            </div>
                            <div :class="isChangeSetting ? 'vx-col w-3/12' : 'vx-col w-1/2'">
                                <input type="color" v-model="item.color" class="w-full" style="height: 37.6px"
                                       :disabled="!isChangeSetting">
                            </div>
                            <div :class="isChangeSetting ? 'vx-col w-4/12 flex justify-around' : 'hidden'">
                                <vs-checkbox :color="item.color" v-model="item.isDoing" @input="changeStatus(item, 1)" :disabled="item.status < 4">Doing</vs-checkbox>
                                <vs-checkbox :color="item.color" v-model="item.isCompleted" @input="changeStatus(item, 2)" :disabled="item.status < 4">Completed</vs-checkbox>
                                <vs-checkbox :color="item.color" v-model="item.isCanceled" @input="changeStatus(item, 3)" :disabled="item.status < 4">Canceled</vs-checkbox>
                            </div>
                            <div :class="isChangeSetting ? 'vx-col w-1/12 flex item-center justify-center' : 'hidden'">
                                <vx-tooltip :text="$t('button.delete')" v-if="item.status > 3"
                                            class="flex items-center">
                                    <feather-icon svg-classes="h-6 w-6" icon="XSquareIcon" class="text-danger"
                                                  @click=" removeItem(index)"></feather-icon>
                                </vx-tooltip>
                            </div>
                        </div>
                    </div>
                </transition-group>
            </draggable>
            <div class="mt-8" v-if="isChangeSetting">
                <vs-button icon-pack="feather" icon="icon-plus" @click="addItem">{{ $t('settings.add') }}</vs-button>
            </div>
        </div>

    </div>

</template>

<script>
import draggable from "vuedraggable";
import vSelect from 'vue-select'

export default {
    components: {
        draggable,
        vSelect
    },

    data() {
        return {
            isChangeSetting: false,
            statusOptions: [],
            dataView: [],
            body: {},
            isDraging: false,
        }
    },
    created() {
        this.getStt();
    },

    computed: {
        dragOptions() {
            return {
                animation: 200,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },

    methods: {
        endMove() {
            this.isDraging = false
            if (this.dataView && this.dataView.length > 0) {
                this.dataView.forEach((el, index) => {
                    return el.order = index;
                });
            }
        },
        cancelChange() {
            this.isChangeSetting = false
            this.getStt();
        },
        removeItem(index) {
            this.dataView.splice(index, 1);
            if (this.dataView && this.dataView.length > 0) {
                this.dataView.forEach((el, index) => {
                    return el.order = index;
                });
            }
        },
        getStt() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                this.$crm.get(`/setting/organization-task-status/find-by-organization-id`).then((response) => {
                    this.dataView = response.data
                    this.$vs.loading.close()
                    if (response.data && response.data.length > 0) {
                        this.statusOptions = response.data.map(el => {
                            return {
                                value: el.status,
                                label: el.title,
                            }
                        })
                    }
                    resolve(response)
                }).catch(err => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Lỗi',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        color: 'danger',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',

                    });
                })
            })
        },
        saveChange() {
            let item = this.dataView.find(el => el.title.trim().length === 0)
            if (item) {
                return this.$vs.notify({
                    text: 'Không được để trống tiêu đề trạng thái!',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            }
            this.$vs.loading()
            this.$crm.post(`/setting/organization-task-status/save`, this.dataView).then(() => {
                this.$vs.loading.close()
                this.$vs.notify({
                    color: 'success',
                    text: `Lưu thay đổi thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
                this.isChangeSetting = false
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Lỗi',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                })
            })
        },
        addItem() {
            let item = {
                order: this.dataView.length,
                color: "#000000",
                title: "",
                status: this.dataView.length,
                isCompleted: 0,
                isDoing: 1,
                isCanceled: 0
            }

            this.dataView.push(item)
        },

        changeStatus(item, num) {
            switch (num) {
                case 1:
                    item.isDoing = 1
                    item.isCompleted = 0
                    item.isCanceled = 0
                    break
                case 2:
                    item.isDoing = 0
                    item.isCompleted = 1
                    item.isCanceled = 0
                    break
                case 3:
                    item.isDoing = 0
                    item.isCompleted = 0
                    item.isCanceled = 1
                    break
            }
        },
    },
};
</script>

<style></style>
